import { Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, ExternalLink } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import MessagesManager from "@/components/admin/MessagesManager";
import NewsManager from "@/components/admin/NewsManager";
import PostersManager from "@/components/admin/PostersManager";
import MediaManager from "@/components/admin/MediaManager";
import QuotesManager from "@/components/admin/QuotesManager";
import PrestationsManager from "@/components/admin/PrestationsManager";
import StagesManager from "@/components/admin/StagesManager";
import PresentationManager from "@/components/admin/PresentationManager";
import AgendaManager from "@/components/admin/AgendaManager";
import AssociationManager from "@/components/admin/AssociationManager";
import SecurityManager from "@/components/admin/SecurityManager";

export default function AdminDashboard() {
  const { user, logout } = useAuth();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FAF6F0]">
        <p className="text-sm text-stone-500">Chargement...</p>
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin" replace />;

  return (
    <div className="min-h-screen bg-[#FAF6F0]">
      <header className="border-b border-stone-800 bg-[#1E1B18] text-white">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-4 px-4 py-5 sm:px-6">
          <div>
            <p className="font-display text-xl font-bold uppercase tracking-tight">Administration du site</p>
            <p className="text-xs text-stone-400">Les Sonneurs de la Côte · connecté : {user.email}</p>
          </div>
          <div className="flex items-center gap-3">
            <Link
              to="/"
              data-testid="admin-view-site-link"
              className="inline-flex items-center gap-1.5 rounded border border-stone-600 px-4 py-2 text-xs font-bold uppercase text-stone-200 transition-colors duration-300 hover:border-stone-400"
            >
              <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" /> Voir le site
            </Link>
            <button
              onClick={logout}
              data-testid="admin-logout-button"
              className="inline-flex items-center gap-1.5 rounded bg-[#B83227] px-4 py-2 text-xs font-bold uppercase text-white transition-colors duration-300 hover:bg-[#96281E]"
            >
              <LogOut className="h-3.5 w-3.5" aria-hidden="true" /> Déconnexion
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
        <Tabs defaultValue="messages" data-testid="admin-tabs">
          <TabsList className="mb-8 flex h-auto flex-wrap justify-start bg-white">
            <TabsTrigger value="messages" data-testid="admin-tab-messages" className="text-xs font-bold uppercase">Messages</TabsTrigger>
            <TabsTrigger value="agenda" data-testid="admin-tab-agenda" className="text-xs font-bold uppercase">Agenda</TabsTrigger>
            <TabsTrigger value="news" data-testid="admin-tab-news" className="text-xs font-bold uppercase">Actualités</TabsTrigger>
            <TabsTrigger value="posters" data-testid="admin-tab-posters" className="text-xs font-bold uppercase">Affiches</TabsTrigger>
            <TabsTrigger value="media" data-testid="admin-tab-media" className="text-xs font-bold uppercase">Galerie</TabsTrigger>
            <TabsTrigger value="quotes" data-testid="admin-tab-quotes" className="text-xs font-bold uppercase">Citations</TabsTrigger>
            <TabsTrigger value="prestations" data-testid="admin-tab-prestations" className="text-xs font-bold uppercase">Prestations</TabsTrigger>
            <TabsTrigger value="stages" data-testid="admin-tab-stages" className="text-xs font-bold uppercase">Stages</TabsTrigger>
            <TabsTrigger value="association" data-testid="admin-tab-association" className="text-xs font-bold uppercase">Association</TabsTrigger>
            <TabsTrigger value="presentation" data-testid="admin-tab-presentation" className="text-xs font-bold uppercase">Textes &amp; Images</TabsTrigger>
            <TabsTrigger value="compte" data-testid="admin-tab-compte" className="text-xs font-bold uppercase">Compte</TabsTrigger>
          </TabsList>
          <TabsContent value="messages"><MessagesManager /></TabsContent>
          <TabsContent value="agenda"><AgendaManager /></TabsContent>
          <TabsContent value="news"><NewsManager /></TabsContent>
          <TabsContent value="posters"><PostersManager /></TabsContent>
          <TabsContent value="media"><MediaManager /></TabsContent>
          <TabsContent value="quotes"><QuotesManager /></TabsContent>
          <TabsContent value="prestations"><PrestationsManager /></TabsContent>
          <TabsContent value="stages"><StagesManager /></TabsContent>
          <TabsContent value="association"><AssociationManager /></TabsContent>
          <TabsContent value="presentation"><PresentationManager /></TabsContent>
          <TabsContent value="compte"><SecurityManager /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
